import React from 'react'

import {
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  FlexDirection,
  Space,
  Text,
  TextAlign,
  TextArea,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import css from './OrderFeedback.css'

const MAX_CHARACTERS = 250

const negativeSentimentPlaceholder = "We're sorry to hear that. How can we improve?"
const positiveSentimentPlaceholder = 'Can you tell us why?'

type OrderFeedbackTextProps = {
  isSentimentPositive: boolean
  onSubmit: (feedback: string) => void
  textareaRef: React.RefObject<HTMLTextAreaElement>
}

const CustomButton = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

export const OrderFeedbackText = ({
  isSentimentPositive,
  onSubmit,
  textareaRef,
}: OrderFeedbackTextProps) => {
  const [feedback, setFeedback] = React.useState<string>('')

  const placeholder = `${
    isSentimentPositive ? positiveSentimentPlaceholder : negativeSentimentPlaceholder
  } Please don't share your personal info as we're unable to reply directly.`

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={2}
      paddingV={2}
      width="100%"
    >
      <Box>
        <TextArea
          className={css.textarea}
          name="feedback_text"
          ref={textareaRef}
          maxLength={MAX_CHARACTERS}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder={placeholder}
          rows={3}
          value={feedback}
        />
        <Space size={0.5} />
        <Text color={Color.ColdGrey_400} textAlign={TextAlign.Right} size={0}>
          {feedback.length}/{MAX_CHARACTERS}
        </Text>
      </Box>
      <CustomButton
        colorVariant={ButtonColorVariant.Primary}
        disabled={!feedback.trim()}
        onClick={() => onSubmit(feedback.trim())}
      >
        Done
      </CustomButton>
    </Box>
  )
}
